// src/components/GalleryItemDialog.js
import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@material-ui/core";

export default function GalleryItemDialog({
  open,
  mode = "add", // "add" | "edit"
  initialValues,
  onClose,
  onConfirm,
}) {
  const [values, setValues] = useState({
    priority: "",
    title: "",
    description: "",
    imageUrl: "",
  });

  useEffect(() => {
    if (open) {
      setValues({
        priority:
          initialValues?.priority !== undefined &&
          initialValues?.priority !== null
            ? String(initialValues.priority)
            : "",
        title: initialValues?.title ?? "",
        description: initialValues?.description ?? "",
        imageUrl: initialValues?.imageUrl ?? "",
      });
    }
  }, [open, initialValues]);

  const handleChangeField = (field) => (event) => {
    const value = event.target.value;
    setValues((prev) => ({ ...prev, [field]: value }));
  };

  const handleConfirm = () => {
    if (onConfirm) {
      // priority come numero se possibile
      const priorityNum =
        values.priority === "" ? null : Number(values.priority);
      onConfirm({
        ...values,
        priority: Number.isNaN(priorityNum) ? null : priorityNum,
      });
    }
  };

  const dialogTitle =
    mode === "edit" ? "Modifica elemento" : "Aggiungi elemento";
  const primaryLabel = mode === "edit" ? "Conferma" : "Aggiungi";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        <TextField
          label="Priority"
          margin="dense"
          variant="standard"
          fullWidth
          type="number"
          value={values.priority}
          onChange={handleChangeField("priority")}
        />
        <TextField
          label="Title"
          margin="dense"
          variant="standard"
          fullWidth
          multiline
          rows={2}
          value={values.title}
          onChange={handleChangeField("title")}
        />
        <TextField
          label="description"
          margin="dense"
          variant="standard"
          fullWidth
          multiline
          rows={2}
          value={values.description}
          onChange={handleChangeField("description")}
        />
        <TextField
          label="Image URL"
          margin="dense"
          variant="standard"
          fullWidth
          value={values.imageUrl}
          onChange={handleChangeField("imageUrl")}
        />

        {values.imageUrl && values.imageUrl.trim() !== "" && (
          <Box
            mt={2}
            mb={1}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <img
              src={values.imageUrl}
              alt={values.title || "Preview immagine"}
              style={{
                maxWidth: "100%",
                maxHeight: 200,
                objectFit: "contain",
                borderRadius: 4,
                display: "block",
              }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Chiudi</Button>
        <Button color="primary" onClick={handleConfirm}>
          {primaryLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
